import { render, staticRenderFns } from "./postTask.vue?vue&type=template&id=1bb864c5&"
import script from "./postTask.vue?vue&type=script&lang=js&"
export * from "./postTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports